import { environment } from '@env/environment';

/**
 * managed debug logs
 * set 'debug: true/false' in the environment.ts files
 *
 * import this constant in your class and us
 * debug.log('message' [, ...]);
 */
export const debug = {
	log: (message?: any, ...optionalParams: any[]) => {
		if (environment.debug === true) {
			console.log(message, ...optionalParams);
		}
	}
};
